import EpaCard from "../../leap-components/EpaCard";
import ComplianceGrid from "../../leap-components/Compliance/ComplianceGrid";
import { Link } from "react-router-dom";
import { Column } from "react-table";
import { ICompliance } from "../../api/ICompliance";
import { getIconForType } from "../../leap-components/icons/LeapIcons";
import { IComplianceProps } from "../../leap-components/Compliance/IComplianceProps";

interface IViewAllComplianceProps {
  profileNo: string;
}

const ViewAllCompliance = ({ profileNo }: IViewAllComplianceProps) => (
  <span
    className="flex-fill w-100"
    style={{ display: "flex", flexDirection: "column" }}
  >
    <Link
      style={{ marginBottom: "10px" }}
      to={`/licence-profile/${profileNo}/compliance`}
    >
      View all Compliance Records
    </Link>
  </span>
);

const Compliance = ({ licenceProfile }: IComplianceProps) => {
  var bodyElements = (
    <div>
      <ComplianceGrid
        licenceProfile={licenceProfile}
        complianceList={licenceProfile.complianceList}
      />
      <ViewAllCompliance profileNo={licenceProfile.profileNo} />
    </div>
  );

  return <EpaCard title={"Latest Compliance Records"} content={bodyElements} />;
};

export default Compliance;
